import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import Ship from "../Ship.js";
import Sidebar from "./Sidebar.js";
import Offcanvas from "react-bootstrap/Offcanvas";
import Toolbar from "./Toolbar.js";
import { parse, stringify } from "qs";

function Form() {
    const [isVisible, setVisible] = useState(false);
    const [shipData, setShipData] = useState({});
    const parsed = parse(window.location.search, { ignoreQueryPrefix: true })
    const [data, setData] = useState({...{currency: []}, ...parsed});
    
    const updateState = function(data) {
        setData(data);
        const stringified = stringify(data);
        window.history.pushState(data, "", stringified ? '?' + stringified : '/');
    }
   
    const toggleVisible = () => { setVisible(!isVisible); };
    const setStart = (start) => { updateState({ ...data, start }); };

    useEffect(() => {
        // this removes empty values for bridge officers so profession=<blank>
        // doesn't get sent to the server
        const newData = {...data};

        if (newData.bridge_officers) {
            newData.bridge_officers.forEach(function (bridgeOfficer, index) {
                let property;

                for (property in bridgeOfficer) {
                    if (!bridgeOfficer[property]) {
                        delete bridgeOfficer[property];
                    }
                }
            });
        }

        ReactGA.event("filter", newData);

        const fetchData = async () => {
            const response = await fetch(process.env.REACT_APP_API + "?" + stringify(newData));
            const json = await response.json();

            setShipData(json);
        };

        fetchData();
    }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <nav className="navbar bg-primary border-0 border-bottom border-primary">
                <div className="container-fluid">
                    <span className="navbar-brand border-0 mb-0 h1 text-white">
                        🚀 Ship Explorer
                    </span>
                    <button
                        className="navbar-toggler d-lg-none"
                        type="button"
                        onClick={toggleVisible}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
            </nav>
            <form onSubmit={(e) => e.preventDefault()}>
                <div className="row">
                    <Offcanvas
                        show={isVisible}
                        onHide={() => setVisible(false)}
                        responsive="lg"
                        className="col-xl-2 col-lg-3 border-end border-primary"
                    >
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Ship Explorer</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Sidebar data={data} setData={updateState} />
                        </Offcanvas.Body>
                    </Offcanvas>

                    <div className="col">
                        <div className="row">
                            <Toolbar
                                total={shipData.total}
                                start={data.start}
                                limit={20}
                                setStart={setStart}
                            />

                            {shipData.ships &&
                                shipData.ships.map((ship) => (
                                    <Ship
                                        ship={ship}
                                        averages={shipData.averages}
                                        data={data}
                                        setData={updateState}
                                        key={ship.id}
                                    />
                                ))}

                            <Toolbar
                                total={shipData.total}
                                start={data.start}
                                limit={20}
                                setStart={setStart}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}

export default Form;
